import {Separator} from "@project/design-system-web";
import React from "react";

interface ToolCallSummaryProps {
  children?: React.ReactNode;
  isLoading?: boolean;
  loadingText?: string;
  className?: string;
}

export function ToolCallSummary({
  children,
  isLoading,
  loadingText = "Loading...",
  className = "",
}: ToolCallSummaryProps) {
  if (isLoading) {
    return (
      <div
        className={`rounded-medium flex min-h-20 items-center justify-center text-sm ${className}`}
      >
        {loadingText}
      </div>
    );
  }

  return (
    <div className={`rounded-medium p-3 text-sm ${className}`}>
      <div className="flex flex-col gap-2">{children}</div>
    </div>
  );
}

interface ToolCallSummaryRowProps {
  label: React.ReactNode;
  value: React.ReactNode;
}

function ToolCallSummaryRow({label, value}: ToolCallSummaryRowProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="font-medium">{label}</div>
      <div className="text-right">{value}</div>
    </div>
  );
}

function ToolCallSummarySeparator() {
  return <Separator className="my-1" />;
}

ToolCallSummary.Row = ToolCallSummaryRow;
ToolCallSummary.Separator = ToolCallSummarySeparator;
